import React from "react";
import { useTranslation } from "react-i18next";
import backarrow from "../../../assets/images/back-arrow-left.svg";
import closeicon from "../../../assets/images/close.svg";
import { useNavigate } from "react-router-dom";
import useAddMoreCoversFlow from "../../../hooks/useAddMoreCoversFlow";
import useTravelAddMoreCoversFlow from "../../../hooks/useTravelAddMoreCoversFlow";
import useLanguageTranslate from "../../../hooks/useLanguageTranslate";

const AddMoreCoversMotorLayout = ({
    children,
    is_hide_back_btn,
    show_close_btn,
    useTravelFlow = false, // New prop to determine which flow to use
    isFirstStep = false, // New prop: true = close icon, false = back icon
    handleNavigationToPolicyOverview, // Custom handler to navigate back to policy overview
}) => {
    const navigate = useNavigate();
    const motorFlow = useAddMoreCoversFlow();
    const travelFlow = useTravelAddMoreCoversFlow();
    const translate = useLanguageTranslate();
    const { i18n } = useTranslation();
    const isRTL = i18n.resolvedLanguage === "ar";

    // Use the appropriate flow based on the prop
    const { handlePrevSubstep } = useTravelFlow ? travelFlow : motorFlow;

    const handleNavigationClick = () => {
        if (isFirstStep || show_close_btn) {
            // Close button - navigate to policy overview
            if (handleNavigationToPolicyOverview) {
                handleNavigationToPolicyOverview();
            } else {
                navigate(-1);
            }
        } else {
            // Back button - go to previous step
            handlePrevSubstep();
        }
    };

    return (
        <div className="">
            {/* Mobile Navigation - Sticky Top Bar (visible <=767px) */}
            {!is_hide_back_btn && (
                <div className="hidden max767:block sticky top-0 left-0 right-0 bg-white border-b border-gray-100 z-10">
                    <div className="flex items-center justify-between rtl:max767:grid h-14 px-4">
                        {/* Navigation Button - Close on first step, Back on subsequent steps */}
                        <button
                            className={`flex items-center justify-center w-10 h-10 rounded-full bg-gray-100 hover:bg-gray-200 transition-colors ${
                                isRTL ? "order-2" : "order-1"
                            }`}
                            onClick={handleNavigationClick}
                            aria-label={isFirstStep || show_close_btn ? translate("Close", "إغلاق") : translate("Back", "رجوع")}
                        >
                            {isFirstStep || show_close_btn ? (
                                <img src={closeicon} alt="Close" className="w-5 h-5" />
                            ) : (
                                <img
                                    src={backarrow}
                                    alt="Back"
                                    className={`w-5 h-5 ${isRTL ? "rotate-180" : ""}`}
                                />
                            )}
                        </button>
                        {/* Center space for potential title */}
                        <div className={`flex-1 ${isRTL ? "order-1" : "order-2"}`}></div>
                    </div>
                </div>
            )}

            {/* Desktop Navigation (visible >767px) */}
            {!is_hide_back_btn && (
                <div className="block max767:hidden">
                    {!isFirstStep && !show_close_btn && (
                        <button
                            className="backButton bg-navy-blue py-2 rounded mt-20 flex absolute left-[26px] rtl:right-[26px] rtl:left-auto top-0 text-black text-sm not-italic font-semibold leading-6 tracking-[-0.084px]"
                            onClick={handlePrevSubstep}
                        >
                            <img src={backarrow} alt="Back arrow" className="rtl:rotate-180" />
                            <span className="back-text inline">{translate("Back", "رجوع")}</span>
                        </button>
                    )}
                    {(isFirstStep || show_close_btn) && (
                        <button
                            className="py-2 rounded mt-20 flex absolute left-[26px] rtl:right-[26px] rtl:left-auto top-0 text-black text-sm not-italic font-semibold leading-6 tracking-[-0.084px] hidden"
                            onClick={handleNavigationClick}
                        >
                            <img src={closeicon} alt="Close Icon" className="w-5 h-5" />
                        </button>
                    )}
                </div>
            )}

            {/* Content with mobile padding to prevent overlap */}
            <div className={!is_hide_back_btn ? "max767:pt-4" : ""}>
                {children}
            </div>
        </div>
    );
};

export default AddMoreCoversMotorLayout;
